module.exports = __webpack_public_path__ + "img/store-applied.7e9f0f6d.svg";